// Libraries
import React from 'react';

// Components
import ModalV2, { DefaultFooterButtons } from '@/views/components/modals/ModalV2';

// Utils
import { formatMessage } from '@/utils/i18n';
import { MODAL_SIZES } from '@/utils/constants';

type Props = {
  backdropClassName?: string;
  isSaving?: boolean;
  onCancel: () => void;
  onSaveAndClose?: () => void;
  show?: boolean;
};

const SaveUnallocatedPortfolioModal = ({ isSaving, show, onCancel, onSaveAndClose, ...rest }: Props) => {
  const basei18n = 'Portfolios.SaveUnallocatedPortfolioModal';
  const body = <span>{formatMessage(`${basei18n}.Body`)}</span>;
  const title = `${basei18n}.Title`;

  const footerButtonsConfig: DefaultFooterButtons = {
    cancelDisabled: isSaving,
    cancelLabelToLocalize: `${basei18n}.CancelButton`,
    cancelOnClick: onCancel,
    primaryActionLoading: isSaving,
    primaryDisabled: isSaving,
    primaryLabelToLocalize: `${basei18n}.SaveAndCloseButton`,
    primaryOnClick: onSaveAndClose,
  };

  return (
    <ModalV2
      size={MODAL_SIZES.SM}
      modalClassName="body-sm"
      show={show}
      title={title}
      onClose={onCancel}
      body={body}
      defaultFooterButtons={footerButtonsConfig}
      {...rest}
    />
  );
};

export default SaveUnallocatedPortfolioModal;
